import React from 'react';
import { Box, Container, Typography, Link } from '@mui/material';
import ClassificationBannerHeader from '../../common/banner/classifactionBannerHeader';
import PageHeader from '../../common/banner/pageHeader';
import ComplianceDashboard from '../../common/buttons/complianceDash';

export default function SOCDetails() {

  const baseRoute = process.env.REACT_APP_BASE_ROUTE || '/';
  const imgRoute = 'images/analytics/cis-details1.png';
  const imgRoute2 = 'images/analytics/cis-details2.png';
  const route = baseRoute + imgRoute;
  const route2 = baseRoute + imgRoute2;
  
  return (
    <Container sx={{ minWidth:1800, mt: 10, mb: 10 }}>
      <Box sx={{pt: 2}}>
        <ClassificationBannerHeader></ClassificationBannerHeader>
        <PageHeader title="CCG Dashboards"></PageHeader>
      </Box>
      <Typography variant='h4' 
        sx ={{display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'center', 
              fontSize: '1.35em', 
              marginBottom: '10px'}}>
        SOC Details
      </Typography>
      <ComplianceDashboard></ComplianceDashboard>
      <Box
        sx={{          
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column'
        }}
      >
      <img 
          alt="SOC Info"
          src={route}
          width='1695px'
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginTop: '10px', marginBottom: '0px'}}
      />
      <img 
          alt="SOC Info"
          src={route2}
          width='100%'
          height="100%"
          style={{ border: 'none', display: 'flex', objectFit: 'none', marginTop: '-20px', marginBottom: '-70px'}}
      />
      </Box>
    </Container>
  );
};